import { render, staticRenderFns } from "./RecentPagesWidget.vue?vue&type=template&id=9f442acc&scoped=true"
import script from "./RecentPagesWidget.vue?vue&type=script&lang=js"
export * from "./RecentPagesWidget.vue?vue&type=script&lang=js"
import style0 from "./RecentPagesWidget.vue?vue&type=style&index=0&id=9f442acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f442acc",
  null
  
)

export default component.exports